export default "__VITE_ASSET__BIUX1mmV__"